<template>
	<div>
		<PersonalBanner />
		<div class="content-zsy">
			<div class="title-wrap">
				<h3>회원리뷰</h3>
				<h4>남들은 어떤 상품을 살까? 궁금하시죠?</h4>
				<div class="summary">나만 모르는 아이템을 회원님들께서 직접 구입한 100% 실제 리뷰예요!</div>
			</div>
			<div class="list-top">
				<div class="page-info">
					회원리뷰<span class="main-color">{{total}}개</span>
				</div>
				<div class="page-list" v-if="!isMobile">
					<el-input v-model="search" class="search" clearable  placeholder="검색어를 입력해주세요."></el-input>
					<el-button type="primary"  @click="onSearch">검색 <i class="el-icon-search"></i></el-button>
					
				</div>
			</div>
			<el-row class="list-wrap">
				<el-col :xs="12" :sm="6" v-for="(item, index) in list" :key="index">
					
					<div class="list-item">
						<a  @click="onDetails(item.id)"  class="event-click-item" >
							<div class="img-wrap">
								<div class="img-item">
									<img loading="lazy"  :src="item.goods_image" alt="">
								</div>
							</div>
							<div class="item-info">
								<div class="name">{{item.nickname}}</div>
							<div class="title">
								{{item.comment_content}}              
							</div>
							<div class="detail">
								<span class="category">{{item.cate_name}}</span>
								<span class="price">¥{{item.price}}</span>
							</div>
							</div>
						</a>
					</div>
					
				</el-col>
	<!-- 			<el-col :xs="12" :sm="6" >
					<div class="list-item">
						<a href="" class="event-click-item" data-index="0">
							<div class="img-wrap">
								<div class="img-item">
									<img loading="lazy"  src="https://www.postteam.co.kr/data/files/2025/11/09/thumb_14950886adb3cb69c7c944df9ade3da4.jpg" alt="">
								</div>
							</div>
							<div class="item-info">
								<div class="name">류*연</div>
							<div class="title">
								안경 케이스 같은 소 제품도 안전히 와요                    
							</div>
							<div class="detail">
								<span class="category">식품 ※ 4KG초과 선적불가.</span>
								<span class="price">¥16.80</span>
							</div>
							</div>
						</a>
					</div>
				</el-col> -->
				
			</el-row>
			
			
			<div class="page">
				<el-pagination  class="white-bg-pagination" 
					layout="prev, pager, next" :page-size="20"
					:total="total"  @current-change="handleCurrentChange">
				</el-pagination>
			</div>
			<div class="btn-wrap text-center">
				<el-button type="primary" round @click="onReview">리뷰 작성하기<i class="el-icon-arrow-right el-icon--right"></i></el-button>
			</div>
		</div>
		
	</div>
</template>

<script>
	import PersonalBanner from '../../components/PersonalBanner.vue'
	import request from '@/utils/request'
	export default {
		components: {
			PersonalBanner
		},
		data() {
			return{
				total:0,
				page:1,
				search: '',
				list: [],
				
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},
		created() {
			this.getList()
		},
		methods: {
			onReview(){
				this.$router.push(`/reviewWriteble`)
			},
			getList(){
				request.post('/Comment/getCommentList',
					{
						search:this.search,
						page:this.page,
					}
				).then(res => {
					console.log(res,"列表")
					if(res.code ==1){
						this.total = res.data.total
						this.list= res.data.data//this.tableData.concat(res.data.data)
					}		
				});
			},
			onDetails(id){
				console.log(id)
				this.$router.push(`/reviewDetails/${id}`)
			},
			onSearch(){
				console.log(this.search,333333333333)
				//this.search = value
				this.page = 1
				this.getList()
			},
			handleCurrentChange(val) {
			    console.log(`当前页: ${val}`);
				this.page = val
				this.getList()
			},
		}		
		
	}
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: #111;
		margin-bottom: 60px;
	}
	.title-wrap h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    margin: 0 0 19px;
	}
	.title-wrap h4 {
	    font-weight: 700;
	    font-size: 36px;
	    line-height: 1.34;
		color: var(--frontground-color);
	    margin: 0;
	}
	.title-wrap .summary{
		padding-top: 10px;
		color: var(--frontground-color);
	}
	.list-top {
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    margin-bottom: 40px;
	}
	.list-top .page-info {
	    font-size: 30px;
	    font-weight: bold;
	    color: var(--frontground-color);
	}
	.main-color {
	    color: var(--main-color);
	}
	.page-list {
	    display: flex;
	    gap: 0 10px;
	}
	/* 列表 */
	.list-wrap .list-item {
	    border: 1px solid #EEEEEE;
	    border-radius: 20px;
	    overflow: hidden;
		margin: 0 10px 30px;
	}
	.list-wrap .list-item a {
	    display: block;
	    text-decoration: none;
	    color: #111;
	    background-color: #fff;
	}
	.list-wrap .list-item .img-wrap {
	    position: relative;
	    padding-bottom: 206px;
	}
	.list-wrap .list-item .img-wrap .img-item {
	    position: absolute;
	    top: 0;
	    left: 0;
	    right: 0;
	    bottom: 0;
	}
	.list-wrap .list-item .img-wrap .img-item img {
	    width: 100%;
	    height: 100%;
	    object-fit: cover;
	}
	.list-wrap .list-item .item-info {
	    padding: 20px 16px;
	}
	.list-wrap .list-item .item-info .name {
	    background: url("../../assets/icon/ico_review_user.png") no-repeat left center;
	    padding-left: 42px;
	    font-size: 12px;
	    line-height: 32px;
	    margin-bottom: 15px;
	    color: rgba(0, 0, 0, 0.5);
	}
	.list-wrap .list-item .item-info .title {
	    font-weight: 700;
	    font-size: 15px;
	    line-height: 18px;
	    margin-bottom: 15px;
	    overflow: hidden;
	    text-overflow: ellipsis;
	    white-space: nowrap;
	}
	.list-wrap .list-item .item-info .detail {
	    display: flex;
	    gap: 0 9px;
	    align-items: center;
	}
	.list-wrap .list-item .item-info .detail .category {
	    padding: 0 10px;
	    line-height: 28px;
	    background: #F3F3F3;
	    border-radius: 36px;
	    font-weight: 500;
		overflow: hidden;
		white-space: nowrap;
	}
	.list-wrap .list-item .item-info .detail .price {
	    font-weight: 600;
	    font-size: 15px;
	    line-height: 18px;
	}
	.page{
		padding-top: 20px;
		text-align: center;
	}
	.btn-wrap {
	    margin-top: 60px;
	}
	.text-center {
	    text-align: center !important;
	}
	
	/* 分页背景 */
	::v-deep .el-pager li {
		background-color: #121212;
	}
	::v-deep .el-pagination button:disabled {
		background-color: #121212;
	}
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-size: 18px;
			color: #0055D4;
			font-weight: bold;
			line-height: 23px;
		}
		.title-wrap h4 {
			font-weight: 700;
			font-size: 30px;
			line-height: 39px;
			text-align: center;
		}
		.list-top .page-info {
		    font-size: 20px;
			padding:0 10px;
		}
		/* 列表 */
		.list-wrap .list-item {
			margin: 0 5px 20px;
		}
		.btn-wrap {
			margin-bottom: 60px;
		}
		
	}
</style>